"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _MenuOutlined = _interopRequireDefault(require("@ant-design/icons-svg/lib/asn/MenuOutlined"));

var _AntdIcon = _interopRequireDefault(require("../components/AntdIcon"));

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var MenuOutlined = function MenuOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, Object.assign({}, props, {
    ref: ref,
    icon: _MenuOutlined.default
  }));
};

MenuOutlined.displayName = 'MenuOutlined';

var _default = /*#__PURE__*/React.forwardRef(MenuOutlined);

exports.default = _default;